module.exports = __webpack_public_path__ + "img/hr-level1_idle_gun_shadow.bdad6727.png";